export const HUB_OPEN_SUCCESS = "HUB_OPEN_SUCCESS"
export const HUB_CLOSE_SUCCESS = "HUB_CLOSE_SUCCESS"


export const GET_SINGLE_HUB_REQUEST = 'GET_SINGLE_HUB_REQUEST'
export const GET_SINGLE_HUB_SUCCESS = 'GET_SINGLE_HUB_SUCCESS'
export const GET_SINGLE_HUB_FAIL = 'GET_SINGLE_HUB_FAIL'


